import { render, staticRenderFns } from "./prepared-approve-purchaseleader.vue?vue&type=template&id=19dd2d2f"
import script from "./prepared-approve-purchaseleader.vue?vue&type=script&lang=js"
export * from "./prepared-approve-purchaseleader.vue?vue&type=script&lang=js"
import style0 from "./prepared-approve-purchaseleader.vue?vue&type=style&index=0&id=19dd2d2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports